import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { canvasToBlobWithTimeout, loadImageWithTimeout } from '../utils/canvasUtils.js';

const COPY_STATUS_TIMEOUT = 2000; // milliseconds

const QRCodeSection = ({ textColor, siteUrl = 'https://www.webfretboard.com' }) => {
  const [copyStatus, setCopyStatus] = useState('');

  // Handle copy QR code to clipboard
  const handleCopyQRCode = async () => {
    const svgElement = document.getElementById('qr-code-svg');
    if (!svgElement) {
      setCopyStatus('Error: QR Code not found');
      setTimeout(() => setCopyStatus(''), COPY_STATUS_TIMEOUT);
      return;
    }

    // Check for clipboard API support
    if (!navigator.clipboard || !window.ClipboardItem) {
      setCopyStatus('Error: Clipboard not supported');
      setTimeout(() => setCopyStatus(''), COPY_STATUS_TIMEOUT);
      return;
    }

    try {
      // Convert SVG to canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const svgData = new XMLSerializer().serializeToString(svgElement);
      
      // Convert SVG string to base64 for image source
      const base64String = btoa(svgData);
      const img = await loadImageWithTimeout('data:image/svg+xml;base64,' + base64String, 5000);

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      // Convert canvas to blob with timeout protection
      const blob = await canvasToBlobWithTimeout(canvas, 'image/png', 5000);

      try {
        await navigator.clipboard.write([
          new ClipboardItem({ 'image/png': blob })
        ]);
        setCopyStatus('Copied!');
        setTimeout(() => setCopyStatus(''), COPY_STATUS_TIMEOUT);
      } catch (err) {
        console.error('Failed to copy to clipboard:', err);
        setCopyStatus('Error: Could not copy');
        setTimeout(() => setCopyStatus(''), COPY_STATUS_TIMEOUT);
      }
    } catch (err) {
      console.error('Failed to copy QR code:', err);
      setCopyStatus('Error: Could not copy');
      setTimeout(() => setCopyStatus(''), COPY_STATUS_TIMEOUT);
    }
  };

  return (
    <div style={{
      border: `2px solid ${textColor}`,
      borderRadius: '8px',
      padding: '20px',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      minWidth: '200px'
    }}>
      <h3 style={{ 
        margin: '0 0 15px 0', 
        color: textColor,
        fontSize: '18px'
      }}>
        Share This Site
      </h3>
      <div style={{
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '4px',
        display: 'inline-block',
        marginBottom: '15px'
      }}>
        <QRCodeSVG
          id="qr-code-svg"
          value={siteUrl}
          size={150}
          level="H"
          includeMargin={true}
        />
      </div>
      <div style={{
        fontSize: '12px',
        color: textColor,
        opacity: 0.8,
        marginBottom: '10px',
        wordBreak: 'break-word'
      }}>
        {siteUrl}
      </div>
      <button
        onClick={handleCopyQRCode}
        style={{
          padding: '8px 16px',
          cursor: 'pointer',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: '1px solid rgb(118, 118, 118)',
          borderRadius: '4px',
          fontWeight: 'bold',
          fontSize: '14px',
          minWidth: '120px'
        }}
      >
        {copyStatus || 'Copy QR Code'}
      </button>
    </div>
  );
};

export default QRCodeSection;
